/**
 * Вход через Telegram без виджета-iframe.
 *
 * Официальный виджет рисует свою кнопку в iframe, и перекрасить её под
 * макет нельзя. Но сам виджет — обёртка над одним редиректом на
 * oauth.telegram.org, который возвращает подписанные данные в хеше URL.
 * Делаем этот редирект сами: кнопка остаётся нашей, данные — теми же.
 *
 * Проверять подпись здесь нельзя и незачем: ключ — токен бота, он есть
 * только у бекенда. Фронт лишь передаёт то, что вернул Telegram.
 */

/** Числовой id бота — часть токена до двоеточия. Пусто — вход выключен. */
export const TELEGRAM_BOT_ID: string = (import.meta.env.VITE_TELEGRAM_BOT_ID ?? '').trim()

export interface TelegramUser {
  id: number
  first_name?: string
  last_name?: string
  username?: string
  photo_url?: string
  auth_date: number
  hash: string
}

/** Куда отправить браузер, чтобы Telegram спросил разрешение. */
export function telegramAuthUrl(returnTo: string): string {
  const params = new URLSearchParams({
    bot_id: TELEGRAM_BOT_ID,
    origin: globalThis.location.origin,
    return_to: returnTo,
    request_access: 'write',
  })
  return `https://oauth.telegram.org/auth?${params.toString()}`
}

const RESULT_KEY = 'tgAuthResult='

/**
 * Разобрать ответ Telegram из хеша URL: `#tgAuthResult=<base64 JSON>`.
 * Telegram отдаёт base64url без выравнивания — приводим к обычному.
 * Любой мусор — null: решает бекенд, а не мы, но падать на нём не надо.
 */
export function readTelegramResult(hash: string): TelegramUser | null {
  const start = hash.indexOf(RESULT_KEY)
  if (start < 0) return null
  const raw = hash.slice(start + RESULT_KEY.length).split('&')[0] ?? ''
  try {
    const normalized = raw.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4)
    const json = decodeURIComponent(escape(atob(padded)))
    const parsed: unknown = JSON.parse(json)
    if (
      typeof parsed === 'object' && parsed !== null
      && typeof (parsed as TelegramUser).id === 'number'
      && typeof (parsed as TelegramUser).hash === 'string'
      && typeof (parsed as TelegramUser).auth_date === 'number'
    ) {
      return parsed as TelegramUser
    }
    return null
  } catch {
    return null
  }
}
